import {
  Box,
  Flex,
  HStack,
  Heading,
  Icon,
  Image,
  Stack,
  Text,
} from '@chakra-ui/react';
import { useEffect, useRef } from 'react';
import { LuArrowRight, LuCircleCheck, LuLogIn } from 'react-icons/lu';
import { useNavigate } from "react-router-dom";
import { useAuthContext } from 'src/auth/AuthContext';
import { Avatar } from "@/components/ui/avatar"
import { Button } from "@/components/ui/button"
import { useI18n } from 'src/i18n/I18nContext';

const Logout = () => {
  const { t } = useI18n();
  const { logout } = useAuthContext();
  const navigate = useNavigate();
  const didLogout = useRef(false);

  useEffect(() => {
    if (didLogout.current) {
      return;
    }
    didLogout.current = true;
    logout();
    console.info('logged out...');
  }, [logout]);

  return (
    <Flex flex="1" align="center" justify="center" px={{ base: 4, md: 8, xl: 12 }} py={{ base: 6, md: 10 }} bg="gray.50">
      <Flex
        w="full"
        maxW="6xl"
        minH={{ base: 'auto', lg: '620px' }}
        bg="white"
        borderWidth={{ base: '0', lg: '1px' }}
        borderColor="gray.200"
        rounded={{ base: 'none', lg: 'lg' }}
        boxShadow={{ base: 'none', lg: '0 24px 70px rgba(15, 23, 42, 0.10)' }}
        overflow="hidden"
      >
          <Box
            flex="1.08"
            position="relative"
            display={{ base: 'none', lg: 'block' }}
            bg="gray.900"
            >
            <Image
              alt={t('logout.imageAlt')}
              src="/images/trees.webp"
              w="full"
              h="full"
              minH="620px"
              objectFit="cover"
            />
            <Box position="absolute" inset="0" bg="linear-gradient(180deg, rgba(15, 23, 42, 0.04) 0%, rgba(15, 23, 42, 0.76) 100%)" />
            <Stack
              position="absolute"
              left="10"
              right="10"
              bottom="10"
              gap="3"
              color="white"
            >
              <Box w="12" h="1" bg="green.300" rounded="full" />
              <Heading fontSize="3xl" lineHeight="1.1" letterSpacing="0">
                {t('logout.heroTitle')}
              </Heading>
              <Text color="whiteAlpha.900" fontSize="lg" maxW="sm">
                {t('logout.heroText')}
              </Text>
            </Stack>
          </Box>

          <Flex
            flex="1"
            align="center"
            justify="center"
            px={{ base: 0, sm: 6, md: 10, xl: 14 }}
            py={{ base: 4, md: 10 }}
          >
            <Stack
              w="full"
              maxW="29rem"
              mx="auto"
              bg="white"
              borderWidth={{ base: '1px', lg: '0' }}
              borderColor="gray.200"
              rounded="lg"
              boxShadow={{ base: '0 16px 46px rgba(15, 23, 42, 0.08)', lg: 'none' }}
              py={{ base: 7, md: 0 }}
              px={{ base: 5, sm: 8, md: 0 }}
              gap={{ base: 7, md: 8 }}
            >
              <HStack gap="3" align="center">
                <Avatar name={undefined} bg="orange.500" color="white" size="lg" />
                <Stack gap="1">
                  <Heading fontSize={{ base: '3xl', md: '4xl' }} lineHeight="1.08" letterSpacing="0">
                    {t('logout.title')}
                  </Heading>
                </Stack>
              </HStack>

              <Stack gap="4">
                <HStack gap="2" color="green.600">
                  <Icon as={LuCircleCheck} boxSize="5" />
                  <Text fontSize="sm" fontWeight="semibold">{t('logout.status')}</Text>
                </HStack>
                <Text fontSize={{ base: 'md', md: 'lg' }} color="gray.600" lineHeight="1.7">
                  {t('logout.description')}
                </Text>
              </Stack>

              <Stack direction={{ base: 'column', sm: 'row' }} align="stretch" gap="3">
                <Button
                  size="lg"
                  flex="1"
                  bg="blue.500"
                  color="white"
                  _hover={{ bg: 'blue.600' }}
                  onClick={() => navigate('/login')}
                >
                  <Icon as={LuLogIn} />
                  {t('logout.login')}
                </Button>
                <Button
                  size="lg"
                  flex="1"
                  variant="outline"
                  color="gray.700"
                  borderColor="gray.300"
                  _hover={{ bg: 'gray.50', borderColor: 'gray.400' }}
                  onClick={() => navigate('/')}
                >
                  {t('logout.home')}
                  <Icon as={LuArrowRight} />
                </Button>
              </Stack>
            </Stack>
          </Flex>
      </Flex>
    </Flex>
  );
}

export default Logout
